












































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import myTable from '../../../components/table/my-table.vue'
import {QueryManufacturer,CreateManufacturer,EditManufacturer} from '../../../api/basicDictionary'
import myform from '../../../components/form/index.vue'
import syn from './syn.vue'
import itemSyn from '../../materialManagement/materialRegistration/parts/itemSyn.vue'
@Component({
  components:{myTable,myform,syn,itemSyn}
})
export default class extends AbpBase{
    
    list:Array<object> = []
    formShow:boolean = false
    formTitle:string = ''
    formData:object = {}
    formItem:Array<object> = []
    selection:any = []
    selectionChange(selection:any){
        this.selection = selection
    }
    synShow = false
    synData = {}
    itemSynShow = false
    itemSynData = {}
    rowSyn(row){
        this.itemSynData = row
        this.itemSynShow = true
    }
    syn(){
        if(this.selection.length===0){
            this.$message.warning('请选择')
            return false
        }
        this.synData = this.selection.map(item=>{return item.id})
        this.synShow = true
    }
    created() {
        this.getData()   
    }
    async getData(){
        this.table.loading = true
        let res = await QueryManufacturer(this.table)
        this.table.totalCount = res.data.totalCount;
        this.list = res.data.items;
        this.table.loading = false
    }
    pageChange(page:number){
        this.table.page = page
        this.getData();
    }
    pagesizeChange(pagesize:number){
        this.table.pageSize = pagesize
        this.getData();
    }
    addOrEdit(row:object){
        this.formTitle = !row?'新增':'编辑'
        this.formData = {
            name:'',
            pinYin:'',
            wubi:'',
            isActive:true,
        }
        this.formData = Object.assign(this.formData,row)
        this.formItem = [
            {
                column:24,
                show:true,
                label:'生产厂家名称',
                name:'name',
                type:'text',
                placeholder:'请输入生产厂家名称',
                rules:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                ],
                //发成change的回调,
                onchange:async (value)=>{
                    let obj = await this.GetPinYinAndWubi({inputStr:value})
                    let val = eval('(' + obj + ')')
                    this.formData['wubi'] = val.Wubi
                    this.formData['pinYin'] = val.PinYin
                }
            },
            {
                column:24,
                show:true,
                label:'拼音助记符',
                name:'pinYin',
                type:'text',
                placeholder:'请输入拼音助记符',
                rules:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                ]
            },
            {
                column:24,
                show:true,
                label:'五笔助记符',
                name:'wubi',
                type:'text',
                placeholder:'请输入五笔助记符',
                rules:[
                    { required: true, message: '不能为空', trigger: 'blur' },
                ]
            },
            {
                column:24,
                show:true,
                label:'是否激活',
                name:'isActive',
                type:'switch',
            }
        ]
        this.formShow = true
    }
    async submit(data:any){
        let res;
        if(data.id){
            res = await EditManufacturer(data)
        }else{
            res = await CreateManufacturer(data)
        }
        if(res.code===2000){
            this.formShow = false
            this.getData()
        }
    }
    columns:Array<object> = [
        {title:'名称',key:'name'},
        {title:'拼音',key:'pinYin'},
        {title:'五笔',key:'wubi'},
        {
            title:'是否已同步',
            render: (h: any, p: any) => {
                return h('el-tag', {
                    props: {
                        type: p.row.synStatus ? 'success' : 'danger',
                    },
                }, p.row.synStatus ? '已同步' : '未同步' )
            }
        },
        {
            title:'操作',
            width:'120',
            render:(h:any,p:any)=>{
                
                return h('div',[
                    h('el-button', {
                        props: {type: 'text'},
                        directives:[{
                            name:'allow'
                        }],
                        on: {
                            click: () => {
                                this.rowSyn(p.row)
                            }
                        }
                    }, '同步'),
                    h('el-button',{
                        props:{
                            type:'text',
                            size:'small'
                        },
                        directives:[{
                            name:'allow'
                        }],
                        on:{
                            click:()=>{
                                this.$message({
                                    type:'info',
                                    customClass:'messagez',
                                    message:'编辑后将自动同步修改内容到已同步的中心',
                                })
                                this.addOrEdit(p.row)
                            }
                        }
                    },'编辑')
                ])
            }
        },
    ]
}
